/**
 * Email content retention preference; must match `UserProfile` values in `accounts.models`.
 */
export const EMAIL_RETENTION_ALL = "all_emails";
export const EMAIL_RETENTION_COLD_INBOUND_ONLY = "cold_inbound_only";
export const EMAIL_RETENTION_METADATA_ONLY = "metadata_only";

export const EMAIL_RETENTION_OPTIONS = [
  {
    value: EMAIL_RETENTION_ALL,
    title: "Store all emails",
    summary: "Full bodies for imported mail so you can review everything in FlipMail.",
    description: "Keep full content for messages we import so you can review everything in FlipMail.",
  },
  {
    value: EMAIL_RETENTION_COLD_INBOUND_ONLY,
    title: "Cold inbound only",
    summary: "Full bodies for cold pitches only. Default. Other mail stays minimal.",
    description:
      "Default. Keep full content for messages we classify as cold inbound pitches so you can read and draft in FlipMail. Other mail is not stored beyond what the pipeline needs.",
  },
  {
    value: EMAIL_RETENTION_METADATA_ONLY,
    title: "Metadata only",
    summary: "Bodies removed on a schedule. Scores and pipeline fields stay for the product.",
    description:
      "Remove stored message bodies on a schedule and keep derived fields (scores, sender, status) for the product and billing.",
  },
];

export function normalizeEmailRetentionValue(raw) {
  const s = raw != null ? String(raw) : "";
  const allowed = new Set(EMAIL_RETENTION_OPTIONS.map((o) => o.value));
  if (allowed.has(s)) return s;
  return EMAIL_RETENTION_COLD_INBOUND_ONLY;
}
